var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-item-box" }, [
    _c(
      "div",
      { staticClass: "title", style: _vm._height },
      [_vm._t("title")],
      2
    ),
    !_vm.noBorder ? _c("div", { staticClass: "divider" }) : _vm._e(),
    _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }